import React from 'react';

import { createDashboardTableClassName } from './dashboardTableStyles';

type TProps = {
  children: React.ReactNode;
  title: string;
  hasEditorLayout?: boolean;
};

export const DashboardTableRow: React.FC<TProps> = ({
  children,
  title,
  hasEditorLayout,
}) => {
  const rowClassName = createDashboardTableClassName('row', {
    editor: hasEditorLayout,
  });

  const rowTitleClassName = createDashboardTableClassName('row-title');

  return (
    <div className={rowClassName}>
      <div className={rowTitleClassName}>{title}</div>
      {children}
    </div>
  );
};
